import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Spinner } from '../components';
import PullToRefresh from 'pulltorefreshjs';

export const usePullToRefresh = () => {
  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches;

    if (standalone) {
      PullToRefresh.init({
        onRefresh() {
          window.location.reload();
        },
        iconRefreshing: ReactDOMServer.renderToString(<Spinner size={12} isLoading />),
        triggerElement: 'header',
      });
    }

    return () => PullToRefresh.destroyAll();
  }, []);
};
